import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { memberMessagesReducer } from './member-messages.reducer';
import { MemberMessagesEffects } from './member-messages.effects';

@NgModule({ imports: [StoreModule.forFeature('memberMessages', memberMessagesReducer), EffectsModule.forFeature([MemberMessagesEffects])] })
export class MemberMessagesModule {}
